exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!../../assets/css/base.css"), "");

// module
exports.push([module.id, ".info{padding:.2rem .4rem;font-family:PingFangSC-Regular;font-size:.26rem;color:#333;text-align:justify;line-height:.4rem;background:#fff}.info>div,.info>p{margin-bottom:.2rem}.info>p{color:#151515;font-weight:700}.info>p.align{text-align:center;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54fc4fd6","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/landingPage/ecardHWPolicy.vue
// module id = 655
// module chunks = 22